module.exports = __webpack_public_path__ + "static/media/loader.82eca827.svg";